/**
 * Icon mapping for portlets
 * Maps icon keys to their actual emoji/icon values
 * This allows easy updates and type safety
 */
export const ICON_MAP = {
  DIRECTOR_DASHBOARD: "🏫",
  ACADEMIC_DASHBOARD: "📊",
  ANALYTICS: "📈",
  LEARNING_MODULES: "🎓",
  ACTIVITIES: "📚",
  SALES: "💼",
  DASHBOARD: "📋",
  ATTENDANCE: "✓",
  TIMETABLE: "📅",
  DOUBTS: "❓",
  RAG: "🧠",
  RUBRIC: "📝",
  AI_GRADING: "✨",
  NEW_TIMETABLE: "📆",
  SCHEDULES: "🗓️",
  SCHEDULES_TEMPLATES: "📋",
  APPROVE: "✅",
  STUDENT_AFFAIRS: "🏠",
  MASTERS_PHD: "🎓",
  LESSON_PLAN: "📘",
  STAFF_LOCATION_ATTENDANCE: "📍",
  TDE: "🎯",
  INVENTORY: "📦",
  TEST_ANALYSIS: "📊",
  AR_REPORTS: "📑",
  BATCH_ANALYSIS: "📋",
  LCS_ACCESS: "🔓",
  STUDY_RESOURCES: "📖",
  CASE_STUDIES: "🧩",
  MY_RESOURCES: "📂",
  PLAN: "🗂️",
  DATA_INGESTION: "📥",
  MENTEES: "👨‍🏫",
  GRID_REPORT: "📊",
  COURSE_MANAGEMENT: "📚",
  EXECUTIVE_DASHBOARD: "📊",
  AI_USAGE: "🤖",
  EMPLOYEE_MANAGEMENT: "👥",
  MEGAPHONE: "📣",
  ENVELOPE: "✉️",
  SUBSTITUTION: "🔁",
  NOTIFICATION_OUTBOX: "📧",
  AGENT_DASHBOARD: "🧑‍💼",
  COUNTRY_MANAGER: "🌏",
  SCORM_COURSES: "📦",
  COMPLIANCE: "🛡️"
} as const;

export type IconKey = keyof typeof ICON_MAP;

/**
 * Resolves an icon configuration to its display value
 * Supports both legacy format (value) and new format (key)
 */
export function resolveIcon(icon: { type: string; value?: string; key?: IconKey }): string {
  if (icon.key && icon.key in ICON_MAP) {
    return ICON_MAP[icon.key];
  }
  // Fallback to value for backward compatibility
  return icon.value || "📄";
}
